export default function Django_Install() {
  return <div>Django_Install Component</div>;
}
